import { render } from "./PDFLink.vue?vue&type=template&id=d89c1cf0&scoped=true"
import script from "./PDFLink.vue?vue&type=script&lang=js"
export * from "./PDFLink.vue?vue&type=script&lang=js"

import "./PDFLink.vue?vue&type=style&index=0&id=d89c1cf0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d89c1cf0"]])

export default __exports__